import { useLocation } from "react-router-dom";
import Button from "Components/Button";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { deleteConfirmationRequest } from "../../Redux/Slices/authSlice";
import assets from "../../Assets";

const DeleteConfirmation = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const dispatch = useDispatch();

  const encryptedSlug = searchParams.get("encryptedSlug");
  const iv = searchParams.get("iv");
  const handleClick = () => {
    dispatch(
      deleteConfirmationRequest({
        slug: encryptedSlug,
        iv: iv,
        data: {
          encryptedSlug: encryptedSlug,
          iv: iv,
        },
        callBack: (data) => {
          console.log(data);
        },
      })
    );
  };

  return (
    <div
      style={{
        fontFamily: "Poppins, sans-serif",
        minHeight: "100vh",
        width: "100%",
        backgroundColor: "white",
        overflow: "auto", 
      }}
    >
      <div
        style={{
          marginTop: "80px", 
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          padding: "20px",
          width: "100%",
          maxWidth: "500px",
          margin: "0 auto",
          boxSizing: "border-box", 
        }}
      >
        <div style={{ width: "100%" }}>
          <div
            style={{
              width: "100%",
              boxShadow: "0 2px 0px rgba(0, 0, 0, 0.09)",
              padding: "20px 0px",
              marginBottom: "30px", 
              display: "flex",
              justifyContent: "center",
            }}
          >
            <img
              src={assets.Icons.kgLogo}
              style={{
                height: "60px", 
                width: "auto",
                margin: "auto",
                maxWidth: "80%", 
              }}
              alt=""
            />
          </div>
        </div>
        <div
          style={{
            fontSize: "20px", 
            color: "grey",
            marginBottom: "20px",
            width: "100%",
            wordWrap: "break-word", 
            overflowWrap: "break-word",
          }}
        >
          Confrim your account deletion by Clicking the below button.
        </div>
        <Button
          title="Confrim Deletion"
          buttonStyle={{
            height: "56px",
            width: "150px",
            padding: "0px 10px",
            background: "#FC0000",
            border: "none",
            marginTop: "10px",
          }}
          onClick={handleClick}
        />
      </div>
    </div>
  );
};

export default DeleteConfirmation;
